import { render, staticRenderFns } from "./MedicalPageWarning.vue?vue&type=template&id=69b5448e&"
import script from "./MedicalPageWarning.vue?vue&type=script&lang=js&"
export * from "./MedicalPageWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpinnerPuff,QScrollArea,QList,QItem,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QSpinnerPuff,QScrollArea,QList,QItem,QCardActions,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
